import React from "react";

const PrivateIcon16pxSvg = ({
    color = "#0EA5E9",
    width = 20,
    height = 20,
    ...props
}) => {
    return (
        <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0009 14.4589C10.7511 14.4589 11.3592 13.8507 11.3592 13.1005C11.3592 12.3503 10.7511 11.7422 10.0009 11.7422C9.25072 11.7422 8.64258 12.3503 8.64258 13.1005C8.64258 13.8507 9.25072 14.4589 10.0009 14.4589Z" fill={color} />
            <path d="M15.2327 7.94102V6.89935C15.2327 4.64935 14.691 1.66602 9.99935 1.66602C5.30768 1.66602 4.76602 4.64935 4.76602 6.89935V7.94102C2.43268 8.23268 1.66602 9.41602 1.66602 12.3243V13.8743C1.66602 17.291 2.70768 18.3327 6.12435 18.3327H13.8743C17.291 18.3327 18.3327 17.291 18.3327 13.8743V12.3243C18.3327 9.41602 17.566 8.23268 15.2327 7.94102ZM9.99935 15.616C8.60768 15.616 7.48268 14.4827 7.48268 13.0993C7.48268 11.7077 8.61602 10.5827 9.99935 10.5827C11.3827 10.5827 12.516 11.716 12.516 13.0993C12.516 14.491 11.391 15.616 9.99935 15.616ZM6.12435 7.86602C6.05768 7.86602 5.99935 7.86602 5.93268 7.86602V6.89935C5.93268 4.45768 6.62435 2.83268 9.99935 2.83268C13.3743 2.83268 14.066 4.45768 14.066 6.89935V7.87435C13.9993 7.87435 13.941 7.87435 13.8743 7.87435H6.12435V7.86602Z" fill={color} />
        </svg>

    );
};

export default PrivateIcon16pxSvg;